<template>
  <div class="popout">
    <div class="hero">
      <div class="floating-shapes">
        <div class="shape"></div>
        <div class="shape"></div>
        <div class="shape"></div>
        <div class="shape"></div>
      </div>
      <div class="hero-content">
        <h1 class="hero-title">Nourish the Brain</h1>
        <p class="hero-subtitle">Where ideas popout and dreams take flight. <br>Let's Make Magic Happen.</p>
        <div class="cta-button" @click="goToBashbet">
          <i class="el-icon-discover"></i>Launch CMS
        </div>
      </div>
    </div>
    <footer class="footer">
      <div class="footer-content">
        <span>© 2026 PopOut. All Rights Reserved.</span>
        <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2024087685号-4</a>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'PopOut',
  methods: {
    goToBashbet() {
      this.$router.push('/admin/welcome')
    }
  }
}
</script>

<style scoped>
.popout {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  min-height: 100vh;
  background: #0a0f1d;
  color: #fff;
  overflow-x: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

.hero {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    circle at center,
    rgba(56, 189, 248, 0.08) 0%,
    transparent 80%
  );
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 900px;
  padding: 2.5rem;
  backdrop-filter: blur(5px);
  background: rgba(15, 23, 42, 0.3);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  width: 90%;
  margin: 2rem auto;
}

.hero-title {
  font-size: 4.5rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin-bottom: 1.8rem;
  background: linear-gradient(135deg, #60a5fa, #a78bfa, #38bdf8);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: fadeInUp 1.2s ease-out;
  text-shadow: 0 5px 15px rgba(56, 189, 248, 0.3);
}

.hero-subtitle {
  font-size: 1.6rem;
  color: #cbd5e1;
  font-weight: 300;
  line-height: 1.5;
  margin-bottom: 3rem;
  animation: fadeInUp 1.2s ease-out 0.2s backwards;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.cta-button {
  display: inline-block;
  padding: 1.2rem 3rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  border: none;
  border-radius: 50px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.4s ease;
  animation: fadeInUp 1.2s ease-out 0.4s backwards;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 30px rgba(59, 130, 246, 0.4);
}

.cta-button:hover::before {
  left: 100%;
}

.cta-button i {
  margin-right: 10px;
}

.floating-shapes {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.shape {
  position: absolute;
  border-radius: 50%;
  animation: float 25s infinite linear;
  opacity: 0.5;
  background: linear-gradient(
    135deg,
    rgba(56, 189, 248, 0.1),
    rgba(139, 92, 246, 0.1)
  );
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.shape:nth-child(1) {
  width: 400px;
  height: 400px;
  top: -200px;
  left: -100px;
  animation-delay: 0s;
}

.shape:nth-child(2) {
  width: 300px;
  height: 300px;
  top: 40%;
  right: -100px;
  animation-delay: -5s;
  background: linear-gradient(
    135deg,
    rgba(139, 92, 246, 0.1),
    rgba(56, 189, 248, 0.1)
  );
}

.shape:nth-child(3) {
  width: 250px;
  height: 250px;
  bottom: -75px;
  left: 30%;
  animation-delay: -10s;
  background: linear-gradient(
    135deg,
    rgba(236, 72, 153, 0.1),
    rgba(56, 189, 248, 0.1)
  );
}

.shape:nth-child(4) {
  width: 200px;
  height: 200px;
  top: 20%;
  left: 20%;
  animation-delay: -15s;
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.1),
    rgba(139, 92, 246, 0.1)
  );
}

@keyframes float {
  0% {
    transform: rotate(0deg) translate(0, 0) scale(1);
  }
  50% {
    transform: rotate(180deg) translate(70px, 70px) scale(1.05);
  }
  100% {
    transform: rotate(360deg) translate(0, 0) scale(1);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 1.2rem;
  background: rgba(10, 15, 29, 0.8);
  backdrop-filter: blur(15px);
  z-index: 10;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.1);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  font-size: 0.9rem;
  color: #94a3b8;
}

.footer a {
  color: #60a5fa;
  text-decoration: none;
  transition: color 0.3s ease;
  position: relative;
}

.footer a::after {
  content: "";
  position: absolute;
  width: 0;
  height: 1px;
  bottom: -2px;
  left: 0;
  background-color: #60a5fa;
  transition: width 0.3s ease;
}

.footer a:hover {
  color: #8b5cf6;
}

@media (max-width: 1024px) {
  .hero-title {
    font-size: 3.8rem;
  }

  .hero-subtitle {
    font-size: 1.4rem;
    max-width: 90%;
  }

  .shape {
    opacity: 0.3;
  }
}

@media (max-width: 768px) {
  .hero-content {
    padding: 2rem;
    width: 95%;
  }

  .hero-title {
    font-size: 2.8rem;
    margin-bottom: 1.5rem;
  }

  .hero-subtitle {
    font-size: 1.3rem;
    max-width: 100%;
    margin-bottom: 2.5rem;
  }

  .cta-button {
    padding: 1rem 2.5rem;
    font-size: 1rem;
  }

  .shape:nth-child(1) {
    width: 200px;
    height: 200px;
  }

  .shape:nth-child(2) {
    width: 150px;
    height: 150px;
  }
}

@media (max-width: 480px) {
  .hero-content {
    padding: 1.5rem;
    background: rgba(15, 23, 42, 0.4);
  }

  .hero-title {
    font-size: 2.2rem;
    margin-bottom: 1.2rem;
  }

  .hero-subtitle {
    font-size: 1.1rem;
    line-height: 1.4;
    margin-bottom: 2rem;
  }

  .footer {
    padding: 0.8rem;
  }

  .footer-content {
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
    font-size: 0.8rem;
  }

  .shape {
    opacity: 0.2;
  }
}

@media (max-width: 360px) {
  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .cta-button {
    padding: 0.9rem 2rem;
    font-size: 0.95rem;
  }
}

@media (max-width: 768px) {
  .hero-content {
    padding: 2rem 1.5rem;
  }

  .hero-title {
    font-size: 2.8rem;
  }

  .hero-subtitle {
    font-size: 1.3rem;
    max-width: 95%;
  }

  .cta-button {
    padding: 1rem 2.5rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 2.3rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .cta-button {
    padding: 0.9rem 2rem;
    font-size: 0.95rem;
  }

  .footer-content {
    flex-direction: column;
    gap: 0.7rem;
  }
}
</style>